import React, { useEffect, useRef } from 'react';
import { getData } from '../utils/sessionStorage';
import { AppConstants, SlowFormCompletionUrl } from '../utils/constants';
import LoadingScreen from '../components/EnrollmentForm/LoadingScreen';
import { trackFormSubmission } from '../utils/monitoring';

const SlowEnrollmentCompletion = () => {
  const userEmail = getData(AppConstants.userEmail);
  const formRef = useRef();

  useEffect(() => {
    trackFormSubmission({
      data: { email: userEmail },
      message: 'Enrollment Portal SlowForm Completion Submitted',
      pageName: 'SlowFormCompletion',
      pageNumber: 6,
    }).then(() => {
      formRef.current.submit();
    });
  }, [userEmail]);

  return (
    <>
      <LoadingScreen />
      <form ref={formRef} method="GET" action={SlowFormCompletionUrl} style={{ visibility: 'hidden' }} noValidate>
        <input type="hidden" name="email" value={userEmail} />
      </form>
    </>
  );
};

export default SlowEnrollmentCompletion;
